import React from "react";
import "../../styles/Tabella.css"

function TabellaOrariAvv() {
    return(
        <div className="table-container">
            <table className="table text-center m-auto" style={{width: "90%"}}>
                <thead>
                <tr>
                    <th className="" scope="col">Lun</th>
                    <th className="" scope="col">Mar</th>
                    <th className="" scope="col">Mer</th>
                    <th className="" scope="col">Gio</th>
                    <th className="" scope="col">Ven</th>
                    <th className="" scope="col">Sab</th>
                    <th className="" scope="col">Dom</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="data-cell">17:00 <br className="d-sm-none"/> - <br className="d-md-none"/> 17:45</td>
                    <td className="data-cell">17:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:45</td>
                    <td className="data-cell">17:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:45</td>
                    <td className="data-cell">17:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:45</td>
                    <td className="data-cell">17:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:45</td>
                    <td className="data-cell">11:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 11:55</td>
                    <td className="data-cell">11:50 <br className="d-sm-none"/> - <br className="d-sm-none"/> 12:30</td>
                </tr>
                <tr>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30</td>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30</td>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30</td>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30</td>
                    <td className="data-cell">17:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 18.30</td>
                    <td className="data-cell">12:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 12:40</td>
                    <td className="data-cell"></td>
                </tr>
                <tr>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                    <td className="data-cell">18:30 <br className="d-sm-none"/> - <br className="d-sm-none"/> 19.15</td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                </tr>
                </tbody>
            </table>
            <div></div>
        </div>
    )
}

export default TabellaOrariAvv